import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import axios from 'axios';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import { onMessageListener } from '../../firebase.messaging';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loonotifi from '../../../safreeimg/safreelogo.png';
import { useNavigate } from 'react-router-dom';

const Page1 = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState('January');
  const [showNotification, setShowNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({});
  const navigate = useNavigate();

  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  const [chartData, setChartData] = useState({
    labels: ['Total Groups', 'Total SubGroups'],
    datasets: [
      {
        label: 'Statistics',
        data: [0, 0],
        backgroundColor: ['#4CAF50', '#FFC107'],
        borderColor: ['#388E3C', '#FFA000'],
        borderWidth: 1,
      },
    ],
  });

  const [dashboardData, setDashboardData] = useState({
    totalGroups: 0,
    totalSubGroups: 0,
  });

  const fetchDashboardData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/org-guardian/my/v1/total-counts';
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        setDashboardData(response.data.data);
      } else {
        console.error('Failed to fetch dashboard data:', response.data.message);
      }
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  const fetchFilteredData = async () => {
    const apiUrl = 'https://api.safree.org/api-v2022/org-guardian/my/v1/total-month-counts';
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Authentication token is missing!');
      return;
    }

    const requestData = {
      year: selectedYear,
      month: selectedMonth.toUpperCase(),
    };

    try {
      const response = await axios.post(apiUrl, requestData, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        const { totalGroups, totalSubGroups } = response.data.data;
        setChartData({
          labels: ['Total Groups', 'Total SubGroups'],
          datasets: [
            {
              label: 'Statistics',
              data: [totalGroups, totalSubGroups],
              backgroundColor: ['#4CAF50', '#FFC107'],
              borderColor: ['#388E3C', '#FFA000'],
              borderWidth: 1,
            },
          ],
        });
      } else {
        console.error('Failed to fetch data:', response.data.message);
      }
    } catch (error) {
      console.error('API Error:', error);
    }
  };


  useEffect(() => {
    fetchDashboardData();
    fetchFilteredData();
  }, [selectedYear, selectedMonth]);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };


  return (
    <div className="container user-management">
      {/* Header */}
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading">Dashboard</p>
        </div>
      </div>

      {/* Cards */}
      <div className="cards-container">
        <a href="/admin3/guardianGroup">
          <div className="cards">
            <h3>Total Groups</h3>
            <p>{dashboardData.totalGroups}</p>
          </div>
        </a>
        <a href="/admin3/guardianSubGroup">
          <div className="cards">
            <h3>Total SubGroups</h3>
            <p>{dashboardData.totalSubGroups}</p>
          </div>
        </a>
      </div>

      {/* Filters */}
      <div className="filters">
        <label>
          Year:
          <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </label>
        <label>
          Month:
          <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
            {[
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December',
            ].map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* Chart */}
      <div className="chart-container" style={{ marginTop: '30px' }}>
        <Bar data={chartData} />
      </div>
    </div>
  );
};

export default Page1;
